import { render, staticRenderFns } from "./Merits.html?vue&type=template&id=c4fe1842&external"
import script from "./Merits.ts?vue&type=script&lang=ts&external"
export * from "./Merits.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports